import { useEffect, useState } from 'react';

type WindowSize = { height: number; width: number };

export const useGetWindowSize = (onlyWhenResizingIsFinished?: boolean): WindowSize | undefined => {
    const [windowSize, setWindowSize] = useState<WindowSize>();

    useEffect(() => {
        let timeoutTimer: number;
        const updateSize = () => {
            if (onlyWhenResizingIsFinished) {
                window.clearTimeout(timeoutTimer);
                timeoutTimer = window.setTimeout(() => {
                    setWindowSize({ height: window.innerHeight, width: window.innerWidth });
                }, 200);
            } else {
                setWindowSize({ height: window.innerHeight, width: window.innerWidth });
            }
        };
        window.addEventListener('resize', updateSize, { passive: true });
        setWindowSize({ height: window.innerHeight, width: window.innerWidth });

        return () => {
            window.removeEventListener('resize', updateSize);
            window.clearTimeout(timeoutTimer);
        };
    }, [onlyWhenResizingIsFinished]);

    return windowSize;
};
